import { ProposalContextData } from '../models/ProposalContextData';
import { ProposalContextService } from '../services/ProposalContextService';
import { TEST_API_PROPOSAL_CONTEXT_DATA } from './APIProposalContextData';

export const TEST_PROPOSAL_CONTEXT_DATA: ProposalContextData =
  ProposalContextService.apiProposalContextToProposalContext(
    TEST_API_PROPOSAL_CONTEXT_DATA,
  );
